<div
  [@currentFieldIndicator]="currentField ? 'show' : 'hide'"
  class="current-field-indicator"
></div>
